import CustomTitle from '../../components/ui/custom-title';
import MetaTagsForm from '../../components/forms/meta-tags.form';

const MetaTagsPage = () => {
  return (
    <>
      <CustomTitle>Управление мета тегами (статические страницы)</CustomTitle>
      <MetaTagsForm />
    </>
  );
};

export default MetaTagsPage;
